export class DatosDocumento {
  constructor(
      public RUC?:string,
      public TipoComprobante?:number,
      public SerieNumero?:string,
      public FechaEmision?:Date,
      public MontoTotal?:number,
      public TokenDB?:string,
      public Servidor?:string,
      public NombreDB?:string,
      public NroCelular?:string,
      public FechaVencimiento?:Date,
      public NumeroDescargas?:number,
  ){ }
}
